<template>
  <md-button
    class="md-danger"
    @click.native="uploadMeters"
    :disabled="!wrapper_getStatus()"
  >{{$lang.keys.send_to_device}}</md-button>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { getStatus } from "@/globalMethods";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
    props: {
        deviceMAC: {
            type: String,
            default: ""
        }
    },
  methods: {
    wrapper_getStatus() {
      return getStatus(this.deviceMAC);
    },

    uploadMeters() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          text: this.$lang.messages.db_in_device_will_be_overwritten,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: "OK",
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            Swal.insertQueueStep({
              title: "Uploading...",
              text: "Please wait",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            });

            axios({
              method: "POST",
              url: this.$ENDPOINTS.API_W + "/applied-precision/upload-database",
              data: {
                device_token: getSelectedDeviceToken(this.deviceMAC),
                meters: true
              },
              withCredentials: true
            })
              .then(() => {
                Swal.fire({
                  title: this.$lang.messages.success,
                  text: "Successfully uploaded meters database",
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                });
              })
              .catch(() => {
                Swal.fire({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    }
  }
};
</script>


